import { Routes } from '@angular/router';
import { StepIds } from '..//models/property-step/property-step-model';
import { PropertyPhotosPageComponent } from '../pages/property-default-pages/property-photos-page/property-photos-page.component';
import { ResidentialForSaleAgentPropertyInformationComponent } from '../pages/category-page-overrides/residential-for-sale-agent/property-information-page.component';
import { ResidentialForSaleAgentPropertyDescriptionComponent } from '../pages/category-page-overrides/residential-for-sale-agent/property-description-page.component';
import { PropertyAgentPromotePageComponent } from '../pages/property-default-pages/property-agent-promote-page/property-agent-promote-page.component';
import { ResidentialForSaleAgentPropertySummaryPageComponent } from '../pages/category-page-overrides/residential-for-sale-agent/property-summary-page.component';

export const residentialForSaleAgentRoutes: Routes = [
    {
        path: '',
        redirectTo: StepIds.propertyInformation,
        pathMatch: 'full'
    },
    {
        path: StepIds.propertyInformation,
        component: ResidentialForSaleAgentPropertyInformationComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyInformation
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-sale-agent/property-information-page.module'
            ).then(
                (mod) =>
                    mod.ResidentialForSaleAgentPropertyInformationPageModule
            )
    },
    {
        path: StepIds.propertyDescription,
        component: ResidentialForSaleAgentPropertyDescriptionComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyDescription
            }
        },
        loadChildren: () =>
        import(
          '../pages/category-page-overrides/residential-for-sale-agent/property-description-page.module'
          ).then((mod) => mod.ResidentialForSaleAgentPropertyDescriptionPageModule)
    },
    {
        path: StepIds.propertyPhotos,
        component: PropertyPhotosPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPhotos
            }
        }
    },
    {
        path: StepIds.propertyPromote,
        component: PropertyAgentPromotePageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertyPromote
            }
        },
        loadChildren: () =>
            import(
                '../pages/property-default-pages/property-agent-promote-page/property-agent-promote-page.module'
            ).then(
                (mod) => mod.PropertyAgentPromotePageModule
            )
    },
    {
        path: StepIds.propertySummary,
        component: ResidentialForSaleAgentPropertySummaryPageComponent,
        data: {
            stepInfo: {
                stepId: StepIds.propertySummary
            }
        },
        loadChildren: () =>
            import(
                '../pages/category-page-overrides/residential-for-sale-agent/property-summary-page.module'
            ).then(
                (mod) => mod.ResidentialForSaleAgentPropertySummaryPageModule
            )
    }
];
